'use client';

import { setCookie } from '@/utils/cookie/BrowserCookie';
import { useLocale } from 'app/[locale]/hooks/useTranslate';
import { Locales } from 'app/[locale]/hooks/useTranslate';
import clsx from 'clsx';
import { ArrowDown, CallaboPopover } from 'libs/callabo-ui/common/Popover/CallaboPopover';
import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';

export const LocaleMenu = ({ disableCookie = false }: { disableCookie?: boolean }): JSX.Element => {
  const savedLocale = useLocale();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const handleChangeLanguage = async (locale: Locales) => {
    if (savedLocale === locale || disableCookie) return;
    setCookie('locale', locale, 30 * 24 * 60 * 60); // 쿠키 만료일: 30일
  };

  return (
    <CallaboPopover
      options={{
        anchor: 'none',
        backdrop: {
          className: 'fixed inset-0 bg-black bg-opacity-0',
        },
        panel: {
          className: 'fixed -translate-x-14 translate-y-3 overflow-hidden',
        },
      }}
    >
      <button className="flex justify-center items-center gap-1">
        <Image
          src={'/callabo/homepage/locale.svg'}
          width={32}
          height={32}
          className="min-w-8 min-h-8 shrink-0"
          alt="lang"
        />
        <ArrowDown className="opacity-50" />
      </button>
      {() => (
        <ul
          className={clsx(
            'w-[120px] bg-navy-deep rounded-lg drop-shadow py-1.5 px-1 z-[100] overflow-hidden'
          )}
        >
          <a
            href={
              pathname.replace(`/${savedLocale}`, '/ko') +
              (searchParams.toString() ? `?${searchParams.toString()}` : '')
            }
          >
            <li
              onClick={() => handleChangeLanguage('ko')}
              className="text-sm text-center text-white cursor-pointer py-3.5 rounded"
            >
              한국어
            </li>
          </a>
          <a
            href={
              pathname.replace(`/${savedLocale}`, '/en') +
              (searchParams.toString() ? `?${searchParams.toString()}` : '')
            }
          >
            <li
              onClick={() => handleChangeLanguage('en')}
              className="text-sm text-center text-white cursor-pointer py-3.5 rounded"
            >
              English
            </li>
          </a>
          <a
            href={
              pathname.replace(`/${savedLocale}`, '/ja') +
              (searchParams.toString() ? `?${searchParams.toString()}` : '')
            }
          >
            <li
              onClick={() => handleChangeLanguage('ja')}
              className="text-sm text-center text-white cursor-pointer py-3.5 rounded"
            >
              日本語
            </li>
          </a>
        </ul>
      )}
    </CallaboPopover>
  );
};
